/* Auto-drifting product rails.
   The rail is a real overflow-x scroller, so touch, trackpad and drag all work
   natively; the drift is just scrollLeft nudged on each frame. That is why the
   user can take over at any moment without fighting an animation. Interaction
   pauses the drift and it resumes after a short idle. The markup renders the
   products twice, so wrapping at the halfway point is invisible. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  function init(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = '1';

    var paused = false, idle = 0, last = 0, half = 0;
    var secs = parseFloat(rail.dataset.speed || '45');

    function measure() { half = rail.scrollWidth / 2; }
    measure();
    addEventListener('resize', measure, { passive: true });

    function hold(ms) { paused = true; idle = ms || 2200; }

    ['pointerdown', 'touchstart', 'wheel', 'mouseenter', 'focusin'].forEach(function (ev) {
      rail.addEventListener(ev, function () { hold(); }, { passive: true });
    });
    rail.addEventListener('mouseleave', function () { idle = 500; }, { passive: true });

    function frame(now) {
      if (!last) last = now;
      var dt = Math.min(now - last, 50);
      last = now;

      if (paused) {
        idle -= dt;
        if (idle <= 0) paused = false;
      } else if (half > 0 && !document.hidden) {
        // full loop of one run takes `secs`, so px/ms is half / (secs*1000)
        rail.scrollLeft += (half / (secs * 1000)) * dt;
      }
      if (half > 0 && rail.scrollLeft >= half) rail.scrollLeft -= half;
      requestAnimationFrame(frame);
    }

    if (!reduce.matches) requestAnimationFrame(frame);
  }

  function boot() {
    document.querySelectorAll('.rail[data-autoscroll]').forEach(init);
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
